import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { Sponsor, Team } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Sponsor";
export const SponsorService = {
	endpoint,
	createSingle: async (data: Sponsor) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Sponsor) => await Service.updateSingleById(endpoint, id, data),
}